import React, { useContext, useState } from "react";
import "../Styles/Sidebar.css";
import { Link, useParams } from "react-router-dom";
import { MyContext } from "../../context/context";
import { GiCash } from "react-icons/gi";
import { FaChartBar } from "react-icons/fa";

const StudentProfileSidebar = () => {
  const { isSidebarOpen, setIsSidebarOpen } = useContext(MyContext);

  const { tab } = useParams();
  const [user] = useState(() => {
    const stored = localStorage.getItem("student");
    return stored ? JSON.parse(stored) : null;
  });

  const getItemStyle = (path) => {
    return path === tab ? "active" : "";
  };
  return (
    <aside className={` student-sidebar ${isSidebarOpen ? "open" : "close"} `}>
      <div className="profile-box">
        <div className="profile-pic">
          <img
            src={user.profileImage}
            alt="profile"
            className="student-profile-img"
          />
        </div>
        <div>
          <div className="profile-name">{user.student.studentName}</div>
          <div className="profile-email">{user.student.email}</div>{" "}
        </div>
      </div>
      <ul className="sidebar-menu">
        <Link to="/profile/project-submissions" className="link-item">
          <li className={getItemStyle("project-submissions")}>
            <FaChartBar /> Project Submissions
          </li>
        </Link>

        <Link to="/profile/help" className="link-item">
          <li className={getItemStyle("help")}>
            <i className="fas fa-question-circle"></i> Help Response
          </li>{" "}
        </Link>

        <Link to="/profile/referral" className="link-item">
          <li className={getItemStyle("referral")}>
            <GiCash />
            My Referrals
          </li>{" "}
        </Link>

        {/* <li>
          <a href="#">
            <i className="fas fa-tachometer-alt"></i> Dashboard
          </a>
        </li> */}
        {/* <li>
          <a href="#">
            <i className="fas fa-book"></i> My Courses
          </a>
        </li> */}

        {/* <li>
          <a href="#">
            <i className="fas fa-chart-line"></i> Progress
          </a>
        </li> */}
        {/* <li>
          <a href="#">
            <i className="fas fa-file-alt"></i> Exams & Projects
          </a>
        </li> */}
        {/* <li>
          <a href="#">
            <i className="fas fa-file-code"></i> Cheat Sheets
          </a>
        </li> */}
        {/* <li>
          <a href="#">
            <i className="fas fa-cog"></i> Settings
          </a>
        </li> */}
      </ul>
    </aside>
  );
};

export default StudentProfileSidebar;
